import axios from 'axios'
import utils from '../assets/js/utils'

const HTTPUtil = {
    get:(url, x) => {
        return axios(url, x)
    },
    post:(url, formData, callback) => {
        let param = '';
        if (formData) {
            param = `&${getParam(formData)}`
        }
        console.log(param, "param");
        //3DES加密
        let secret = utils.encrypt(param);
        let bodyKeyValue = `secret=${secret}`
        axios.post(url, bodyKeyValue).then(res => {
            let data = res.data;
            if(data.data){
                let decryptData = utils.decrypt(data.data);
                data.data = JSON.parse(decryptData)?JSON.parse(decryptData):'';
            }
            callback(data)
        }, err => {
            callback({errCode: false, errMsg: "接口请求异常", data: err })
        })
    }
}

// 序列化
const getParam = (json) => {
    let myArray = []
    for (var key in json) {
        console.log(typeof json[key]);
        myArray.push(`${key}=${(typeof json[key] == 'object'?JSON.stringify(json[key]):json[key]) }`)
    }
    return myArray.join('&')
}

export default HTTPUtil


// WEBPACK FOOTER //
// ./src/network/httpUtils.js